var map = {
	"./bd-active.png": "xjNu",
	"./im-active.png": "HS7n",
	"./sb-active.png": "+hIU",
	"./ss-active.png": "O6kw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Vg4";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport ^\.\/.*\-active\.png$
// module id = 4Vg4
// module chunks = 3